<template>

  <div class="pageCardDiagram">
    <div class="row justify-content-center mb-5">
      <div class="col-12">
        <div class="card-diagram-info d-flex justify-content-between">
          <h2>dd.mm.rrrr – dd.mm.rrrr</h2>
          <div class="wrapper-btn">
            <b-button variant="secondary"
                      class="custom px-5 mr-3">
              <span class="icon icon-print pr-2"></span>

              Drukuj
            </b-button>
            <b-button variant="primary"
                      class="custom px-5">
              <span class="icon icon-save pr-2"></span>

              Zapisz
            </b-button>

          </div>
        </div>
      </div>

    </div>
    <div class="row justify-content-center my-5">
      <div class="col-12 ">
        <b-card class="card-status custom">
          <template slot="header">
            <div class="d-flex justify-content-between">
              <h2>Porównanie placówek</h2>


              <b-dropdown id="dropdown-1" text="Sortowanie" variant="defoult" class="custom sort">
                <b-dropdown-item>First Action</b-dropdown-item>
                <b-dropdown-item>Second Action</b-dropdown-item>
                <b-dropdown-item>Third Action</b-dropdown-item>
              </b-dropdown>
            </div>

          </template>
          <b-card-text>
            <div class="row">
              <div class="col-2">
                <div class="td-card-info ">
                  <p>Kraj, Miasto, Adres </p>
                  <span>
                 wejścia: <strong>714</strong>
               </span>
                </div>
              </div>
              <div class="col-10">
                <div class="line-status">
                  <div class="line-status-progres w32">
                    <span>32%</span>
                  </div>
                  <div class="line-status-progres w28">
                    <span>28%</span>

                  </div>
                  <div class="line-status-progres w40">
                    <span>40%</span>

                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <div class="td-card-info">
                  <p>Kraj, Miasto, Adres </p>
                  <span>
                 wejścia: <strong>714</strong>
               </span>
                </div>
              </div>
              <div class="col-10">
                <div class="line-status">
                  <div class="line-status-progres w32">
                    <span>32%</span>
                  </div>
                  <div class="line-status-progres w28">
                    <span>28%</span>

                  </div>
                  <div class="line-status-progres w40">
                    <span>40%</span>

                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <div class="td-card-info">
                  <p>Kraj, Miasto, Adres </p>
                  <span>
                 wejścia: <strong>714</strong>
               </span>
                </div>
              </div>
              <div class="col-10">
                <div class="line-status">
                  <div class="line-status-progres w32">
                    <span>32%</span>
                  </div>
                  <div class="line-status-progres w28">
                    <span>28%</span>

                  </div>
                  <div class="line-status-progres w40">
                    <span>40%</span>

                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
          <template slot="footer">

          </template>
        </b-card>
      </div>

    </div>
    <div class="row justify-content-center my-5">
      <div class="col-2 ">
        <div class="content-emoji text-right">
          <p>oceny: <span>32</span></p>
          <p>wejścia: <span>50</span></p>
          <p>oceny /wejścia: <span class="color-orange">75%</span></p>


        </div>
        <b-card class="card-emoji custom">
          <template slot="header">
            <h2 class="">Podsumowanie
              wyników</h2>


          </template>
          <b-card-text>
            <div class="row ">
              <div class="col-12">
                <div class="wrap-status-face text-center first">
                    <span class="icon icon-smile_"><br>
                      36%
                    </span>
                  <p> 219 opinii</p>
                </div>
                <div class="wrap-status-face text-center two">
                    <span class="icon icon-smile_1"><br>
                      36%
                    </span>
                  <p> 219 opinii</p>
                </div>
                <div class="wrap-status-face text-center tree">
                    <span class="icon icon-smile"><br>
                      36%
                    </span>
                  <p> 219 opinii</p>
                </div>
              </div>
            </div>

          </b-card-text>
          <template slot="footer">

          </template>
        </b-card>
      </div>
      <div class="col-2">
        <div class="content-emoji text-right ">
          <p>oceny: <span>32</span></p>
          <p>wejścia: <span>50</span></p>
          <p>oceny /wejścia: <span class="color-orange">75%</span></p>
        </div>
      </div>
      <div class="col-6 ">

        <b-card class="card-emoji custom wide">
          <template slot="header">
            <h2 class="mb-0">Podsumowanie
              wyników</h2>

          </template>
          <b-card-text>
            <div class="row ">
              <div class="col-12">
                <div class="d-flex justify-content-between">
                  <div class="wrap-status-face  first d-inline-block first">
                    <span class="icon icon-smile_">
                    </span>
                    <div class="d-inline-block  ml-2  ">
                      <span class="mb-0 color-green">36%</span>
                      <p> 219 opinii</p>
                    </div>
                  </div>
                  <div class="wrap-status-face  first d-inline-block two">
                    <span class="icon icon-smile_1">
                    </span>
                    <div class="d-inline-block  ml-2  ">
                      <span class="mb-0 color-orange">36%</span>
                      <p> 219 opinii</p>
                    </div>
                  </div>
                  <div class="wrap-status-face  first d-inline-block tree">
                    <span class="icon icon-smile_ color-red">
                    </span>
                    <div class="d-inline-block  ml-2  ">
                      <span class="mb-0 color-red">36%</span>

                      <p> 219 opinii</p>
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </b-card-text>
          <template slot="footer">

          </template>
        </b-card>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'TableDiagram'
  }
</script>

<style scoped>

</style>
